import type { Diagnostic } from '../lib/tests';

/**
 * Import findings, worst first and each pinned to its line in the source file.
 * The line number is the point: it is what turns "something is wrong with your
 * paper" into a place to put the cursor.
 */
export function DiagnosticList({ diagnostics }: { diagnostics: Diagnostic[] }) {
  if (diagnostics.length === 0) {
    return <p className="muted">Nothing to report — the file read cleanly.</p>;
  }

  const errors = diagnostics.filter((d) => d.severity === 'error');
  const warnings = diagnostics.filter((d) => d.severity === 'warning');

  return (
    <div className="stack" style={{ gap: 'var(--s-3)' }}>
      <p className="muted">
        <span className="mono">{errors.length}</span> problem{errors.length === 1 ? '' : 's'} and{' '}
        <span className="mono">{warnings.length}</span> note{warnings.length === 1 ? '' : 's'}.
      </p>
      <ul className="diaglist">
        {[...errors, ...warnings].map((d, i) => (
          <li key={`${d.line}-${i}`} className={`diaglist__item diaglist__item--${d.severity}`}>
            <span className="mono diaglist__line">line {d.line}</span>
            <span>{d.message}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
